import { render } from "./process-group-attachment.vue?vue&type=template&id=5bb77b3d"
import script from "./process-group-attachment.vue?vue&type=script&lang=js"
export * from "./process-group-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__